import React from 'react';
import { MapPin } from 'lucide-react';
import { inputClass } from './checkoutText';
import { tx } from '@/translations/translations';

export const AddressForm = ({ address, onChange, language, text }) => (
  <div>
    <h3 className="font-semibold text-slate-800 mb-2 flex items-center gap-2 text-sm">
      <MapPin className="w-4 h-4" /> {text.addressTitle}
    </h3>
    <p className="text-[11px] text-amber-600 mb-2">{text.shippingNote}</p>
    <div className="space-y-2">
      <div>
        <label className="block text-[11px] font-medium text-slate-600 mb-0.5">{text.fullName} *</label>
        <input type="text" className={inputClass} value={address.fullName} onChange={(e) => onChange('fullName', e.target.value)} data-testid="address-name" />
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="col-span-2">
          <label className="block text-[11px] font-medium text-slate-600 mb-0.5">{text.street} *</label>
          <input type="text" className={inputClass} value={address.street} onChange={(e) => onChange('street', e.target.value)} data-testid="address-street" />
        </div>
        <div>
          <label className="block text-[11px] font-medium text-slate-600 mb-0.5">
            {tx(language, 'Int / Depto', 'Apt / Suite', 'דירה / כניסה')}
            <span className="ml-1 text-slate-400 font-normal text-[10px]">({tx(language, 'opc.', 'opt.', 'רשות')})</span>
          </label>
          <input
            type="text"
            className={inputClass}
            value={address.interior}
            onChange={(e) => onChange('interior', e.target.value)}
            data-testid="address-interior"
            placeholder={tx(language, 'Ej: 3B', 'E.g.: 3B', 'למשל: 3B')}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="block text-[11px] font-medium text-slate-600 mb-0.5">{tx(language, 'Zona', 'Zone', 'אזור')} *</label>
          <select className={inputClass} value={address.zone} onChange={(e) => onChange('zone', e.target.value)} data-testid="address-zone">
            <option value="">{tx(language, 'Seleccionar...', 'Select...', 'בחרו...')}</option>
            <option value="Interlomas">Interlomas</option>
            <option value="Tecamachalco">Tecamachalco</option>
            <option value="Bosques">Bosques</option>
            <option value="Polanco">Polanco</option>
            <option value="Palmas">Palmas</option>
            <option value="Bosque Real">Bosque Real</option>
            <option value="Otro">{tx(language, 'Otro', 'Other', 'אחר')}</option>
          </select>
        </div>
        <div>
          <label className="block text-[11px] font-medium text-slate-600 mb-0.5">
            {tx(language, 'Entrega a', 'Deliver to', 'מסירה ל')} *
          </label>
          <select className={inputClass} value={address.deliverySpec} onChange={(e) => onChange('deliverySpec', e.target.value)} data-testid="address-delivery-spec">
            <option value="">{tx(language, 'Seleccionar...', 'Select...', 'בחרו...')}</option>
            <option value="Entregar a paquetería">{tx(language, 'Paquetería', 'Courier', 'שליח')}</option>
            <option value="Entregar a seguridad">{tx(language, 'Seguridad', 'Security', 'אבטחה')}</option>
            <option value="Otro">{tx(language, 'Otro', 'Other', 'אחר')}</option>
          </select>
        </div>
      </div>
      {(address.zone === 'Otro' || address.deliverySpec === 'Otro') && (
        <div className="grid grid-cols-2 gap-2">
          {address.zone === 'Otro' && (
            <input
              type="text"
              className={inputClass}
              placeholder={tx(language, 'Especifica zona', 'Specify zone', 'ציינו אזור')}
              value={address.zoneOther}
              onChange={(e) => onChange('zoneOther', e.target.value)}
              data-testid="address-zone-other"
            />
          )}
          {address.deliverySpec === 'Otro' && (
            <input
              type="text"
              className={`${inputClass} ${address.zone === 'Otro' ? '' : 'col-start-2'}`}
              placeholder={tx(language, 'Especifica entrega', 'Specify delivery', 'ציינו מסירה')}
              value={address.deliverySpecOther}
              onChange={(e) => onChange('deliverySpecOther', e.target.value)}
              data-testid="address-delivery-spec-other"
            />
          )}
        </div>
      )}
      <div>
        <label className="block text-[11px] font-medium text-slate-600 mb-0.5">
          <span className="flex items-center gap-1">
            <svg viewBox="0 0 24 24" className="w-3 h-3 fill-cyan-500 inline"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" /></svg>
            WhatsApp *
          </span>
        </label>
        <input type="tel" className={inputClass} value={address.phone} onChange={(e) => onChange('phone', e.target.value)} data-testid="address-phone" placeholder="55 1234 5678" />
      </div>
    </div>
  </div>
);
